module.exports = __webpack_public_path__ + "img/case-logo-3.ec7fb32e.png";